import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Messages e-mail',
  labels: {
    view_full_message: 'Voir le message complet',
    status: 'Statut :',
    on: 'Activé',
    off: 'Désactivé',
  },
  tiles: {
    sends_count: 'Messages envoyés',
    delivery_rate: 'Taux de délivrabilité',
    delivered_suffix: 'délivrés',
    open_rate: "Taux d'ouverture",
    opened_suffix: 'ouverts',
    click_rate: 'Taux de clic',
    clicked_suffix: 'cliqués',
    spam_report_rate: 'Taux de signalement spam',
    spam_reports_suffix: 'signalements',
    unsubscribe_rate: 'Taux de désabonnement',
    unsubscribes_suffix: 'désabonnements',
  },
  toasts: {
    failed_to_update_status: 'Impossible de mettre à jour le statut',
    failed_to_load_data: 'Impossible de charger les données',
  },

  preview_modal: {
    title: 'Aperçu du modèle',
    labels: {
      subject: 'Objet :',
      close: 'Fermer',
    },
    toasts: {
      failed_to_load_data: "Impossible de charger l'aperçu",
    },
    template_data: {
      recipient_name: '&lt;Prénom&gt;',
    },
  },
};
